<template>
	<div class="rowItem">
		<RowForm class="rowItem-detail" v-if="isEdit" :data="editData" :isEditSideScreens="isEditSideScreens" :isNew="!firstSection" @submit="setData"></RowForm>
		<RowDetail class="rowItem-detail" v-else @edit="isEdit = true" @editSideScreens="isEditSideScreens = true; isEdit = true;" :data="editData" :price="price" :rowWidth="rowWidth" :sections="sections"></RowDetail>

		<div class="rowItem-main">
			<RowHead class="rowItem-head" :number="number" @copy="$emit('copy', $event)" @remove="$emit('remove')"></RowHead>
			<div class="rowItem-body" v-if="sections.length">
				<RowSections class="rowItem-sections" v-bind="$props" :rowWidth="rowWidth" @edit="isEdit = true" @updateSection="updateSection"></RowSections>
				<RowNewSection class="rowItem-add" @submit="addSection" :data="editData"></RowNewSection>
			</div>
		</div>
	</div>
</template>

<script>
	import RowDetail from './RowDetail.vue'
	import RowForm from './RowForm.vue'
	import RowHead from './RowHead.vue'
	import RowSections from './RowSections.vue'
	import RowNewSection from './RowNewSection.vue'

	export default {
		props: {
			number: Number,
			capacity: Number,
			height: Number,
			depth: Number,
			sections: Array,
			price: [Number, String],
			beamsType: String,
			coupler: Boolean,
			separate: Boolean,
			accessories: Object
		},
		data() {
			return {
				isEdit: true,
				isEditSideScreens: false,
			};
		},
		computed: {
			firstSection() {
				return this.sections[0];
			},
			editData() {
				return {
					capacity: this.capacity,
					height: this.height,
					depth: this.depth,
					width: this.firstSection ? this.firstSection.width : 900,
					count: this.firstSection ? this.firstSection.count : 3,
					beamsType: this.beamsType,
					coupler: this.coupler,
					separate: this.separate,
					accessories: this.accessories,
					racksType: 'Profi'
				};
			},
			rowWidth() {
				return this.sections.reduce((a, c) => a + c.width, 0) + (this.sections.length + 1) * 56;
			},
		},
		methods: {
			setData(data) {
				this.$emit('update', data)
				this.isEdit = false;
				this.isEditSideScreens = false;
			},
			addSection(data) {
				this.$emit('addSection', data);
			},
			updateSection(section) {
				this.$emit('updateSection', section, section.index);
			},
		},
		components: {
			RowDetail,
			RowForm,
			RowHead,
			RowSections,
			RowNewSection,
		},
	};
</script>

<style scoped>
	.rowItem {
		display: flex;
		margin-bottom: 40px;
	}
	.rowItem-detail {
		margin-right: 30px;
	}
	.rowItem-main {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
	}
	.rowItem-head {
		margin-bottom: 23px;
	}
	.rowItem-body {
		display: flex;
		flex-grow: 1;
	}
	.rowItem-sections {
		margin-right: 23px;
	}
	.rowItem-add {
		margin-top: 41px;
	}
</style>